//
import { StackNavigationProp } from '@react-navigation/stack';
import React, { useEffect, useState } from 'react';
import { Image, Keyboard, Linking, Platform, StyleSheet, Text, View } from 'react-native';
import GoogleLogin from '../Generic/GoogleLogin';
import { TextInput } from 'react-native-paper';
import { StackParamList } from '../../../App';
import colors from '../../colors';
import { SIDE_PADDING, TXT_M } from '../../constants';
import { useSessao } from '../../redux/sessao/sessaoHooks';
import Button from '../Generic/Button';
import Form from '../Generic/Form';
import PageContainer from '../Generic/PageContainer';
import Header from '../Generic/Header';

import * as Notifications from 'expo-notifications';
import { useAlert } from '../../redux/alert/alertHooks';
import CTextInput from '../Generic/CTextInput';
import Touchable from '../Generic/Touchable';
import { useEmpresa } from '../../redux/empresa/empresaHooks';
import EsqueciSenhaDialog from './EsqueciSenhaDialog';

Notifications.setNotificationHandler({
  handleNotification: async () => ({
    shouldShowAlert: true,
    shouldPlaySound: true,
    shouldSetBadge: false
  })
});

type Props = {
  navigation: StackNavigationProp<StackParamList, 'LoginPage'>;
};

const LoginPage: React.FC<Props> = (props) => {
  const navigation = props.navigation;
  // const navigation = useNavigation();
  const [sessao, login, logout] = useSessao();

  const onLogin = async () => {
    Keyboard.dismiss();
    login(email, senha);
  };

  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');

  const [empresa] = useEmpresa();
  // const [mostrarAlert] = useAlert();
  const [dialogEsqueciSenha, setDialogEsqueciSenha] = useState(false);

  useEffect(() => {
    if (sessao.cliente && sessao.token) {
      navigation.goBack();
    }
  }, [sessao.token]);

  return (
    <PageContainer
      containerStyle={styles.container}
      // style={{ justifyContent: 'space-between', flex: 1, height: '100%' }}
      padding={false}
      header={<Header titulo="" goBack />}
    >
      <EsqueciSenhaDialog open={dialogEsqueciSenha} setOpen={() => setDialogEsqueciSenha(false)} />

      <View style={{ backgroundColor: colors.primary, height: 150, width: '100%' }} />
      <Image source={require('../../../assets/logo.png')} style={styles.logo} />

      <View style={styles.content}>
        {
          <>
            <GoogleLogin />
            <Text style={{ color: colors.darkGrey, margin: 20 }}>OU</Text>
          </>
        }

        <Form style={[styles.form, { width: '100%' }]}>
          <CTextInput
            label={'Celular com DDD ou Email'}
            onChangeText={(txt) => setEmail(txt)}
            value={email}
            style={styles.input}
            autoCapitalize="none"
            placeholder={'Ex: 37999881234 ou joao@gmail.com'}
          />

          <CTextInput
            label={'Senha'}
            onChangeText={(txt) => setSenha(txt)}
            value={senha}
            secureTextEntry={true}
            style={styles.input}
          />

          {Boolean(empresa.telefone) && (
            <Touchable style={{ marginBottom: 15 }} onPress={() => setDialogEsqueciSenha(true)}>
              <Text style={{ color: colors.primaryDark, textDecorationLine: 'underline' }}>
                Esqueci minha senha
              </Text>
            </Touchable>
          )}

          <Button title="ENTRAR" onPress={onLogin} backgroundColor={colors.green} />
        </Form>
      </View>

      <Button
        title={'Ainda não é cliente?\nCadastre-se!'}
        onPress={() => navigation.replace('CadastroPage')}
        style={{ marginTop: 20, maxWidth: 210, alignSelf: 'center' }}
      />
    </PageContainer>
  );
};

const styles = StyleSheet.create({
  container: {
    // flex: 1,
    width: '100%',
    // backgroundColor: '#ff0',
    justifyContent: 'space-between',
    flexGrow: 1
  },
  input: {
    borderBottomColor: colors.lightGrey,
    borderBottomWidth: 2,
    width: '100%',
    marginBottom: 12,
    fontSize: TXT_M
  },
  button: {
    borderRadius: 5,
    backgroundColor: colors.button,
    padding: 5,
    paddingLeft: 10,
    paddingRight: 10,
    alignItems: 'center',
    marginBottom: 10
  },
  content: {
    alignItems: 'center',
    justifyContent: 'space-between',
    // flex: 1,
    // height: '100%',
    width: '100%',
    backgroundColor: '#fff',
    borderTopLeftRadius: 30,
    borderTopRightRadius: 30,
    paddingRight: SIDE_PADDING,
    paddingLeft: SIDE_PADDING,
    top: -30,
    paddingTop: 100

    // paddingTop: 100,
    // top: -30
  },
  form: {
    maxWidth: 600
  },
  logo: {
    width: '60%',
    height: 200,
    marginBottom: 30,
    resizeMode: 'contain',
    alignSelf: 'center',
    position: 'absolute',
    top: 0,
    zIndex: 99
  }
});

export default LoginPage;
